<template>
    <div :class="[$style['range-slider'], {[$style['no-change']]: !changed}, {[$style['is-disabled']]: slider.disabled}]"
         v-if="slider">
        <div :class="$style['range-slider__caption']">
            <span>{{ slider.label }}</span>
            <span v-if="slider.valueCaption">{{ slider.valueCaption }}</span>
        </div>

        <div :class="$style['range-slider__value']">
            <input :class="$style['range-slider__input']"
                   type="text"
                   v-model="slider.value"
                   :readonly="slider.disabled"
                   @input="change"
                   @focusout="focusOut"
                   @keypress="isNumber($event)"
                   ref="input">
            <span v-if="slider.post" :class="$style['range-slider__input-post']" v-html="post"></span>
        </div>


        <div :class="[$style['range-slider__range'], slider.tooltip ? $style[`range-slider__range_is_${slider.tooltip}`] : '', {[$style['no-change']]: !changed}]">
            <VueSlider v-if="!slider.disabled"
                       v-model="slider.value"
                       :min="min"
                       :max="max"
                       :interval="slider.interval"
                       :tooltip="slider.tooltip"
                       :tooltip-formatter="val => formatterValue(val)"
                       :contained="true"
                       :dotSize="0"
                       :ref="slider"
                       @change="change"
                       @drag-start="dragStart"
                       @drag-end="dragEnd"></VueSlider>
        </div>

        <input type="hidden" :name="slider.name" :value="slider.value">
    </div>
</template>

<script>
    import InputMask from 'inputmask';
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css'

    export default {
        components: {
            VueSlider
        },

        props: ['slider', 'slug', 'isChanged'],

        data: () => ({
            dragging: false,
            changed: false,
            oldVal: null
        }),

        computed: {
            post() {
                if (this.slider.context) {
                    return this.pluralWord(this.slider.value);
                }

                if (this.slider.post === 'Р' || this.slider.post === '₽') {
                    return '<span class="b-ruble">i</span>';
                }

                return this.slider.post;
            },
            min: {
                get() {
                    return this.slider.min % this.slider.interval ? this.slider.min - this.slider.min % this.slider.interval : this.slider.min;
                },
                set(val) {
                    this.slider.min = val;
                }
            },
            max: {
                get() {
                    return this.slider.max % this.slider.interval ? this.slider.max - this.slider.max % this.slider.interval : this.slider.max;
                },
                set(val) {
                    this.slider.max = val;
                }
            }
        },

        mounted() {
            this.changed = this.isChanged;
            const optionsMask = {
                placeholder   : ' ',
                rightAlign    : false,
                radixPoint    : ',',
                autoGroup     : true,
                groupSeparator: ' ',
                groupSize     : 3,
                autoUnmask    : true
            };

            new InputMask('decimal', optionsMask).mask(this.$refs.input);
        },

        methods: {
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                const charCode = (evt.which) ? evt.which : evt.keyCode;

                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            change() {
                this.changed = true;

                if (this.dragging) {
                    this.$emit('change', this.slug)
                } else {
                    this.$emit('change-end', this.slug)
                }
            },

            focusOut(event) {
                 if (this.slider.value < this.slider.min) {
                     this.slider.value = this.slider.min;

                     this.change(event);
                 } else if (this.slider.value > this.slider.max) {
                     this.slider.value = this.slider.max;

                     this.change(event);
                 }
            },

            dragStart() {
                this.oldVal = this.slider.value;
                this.dragging = true;
                this.changed = true;
                this.$emit('change-start', this.slug)
            },

            dragEnd() {
                if (this.oldVal === this.slider.value) {
                    return;
                }

                this.dragging = false;
                this.$emit('change-end', this.slug)
            },

            formatterValue(val) {
                let value = val;

                if (Number(this.multiply)) {
                    value = Number(val) * Number(this.multiply);
                }

                return (this.slider.price ? this.formatPrice(value) : value);
            },

            formatPrice(value) {
                let val = (value/1).toFixed(0).replace('.', ',');
                return Number(val).toLocaleString('ru-Ru');
            },

            pluralWord(n) {
                const $i = ((n % 10 === 1 && n % 100 !== 11) ? 0 : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2));
                return this.slider.context[$i];
            }
        }
    }
</script>

<style lang="scss" module>
    @import "./RangeSlider";
</style>

<style lang="scss">
    .vue-slider {
        @include scale(padding, 0 10, 0 10, 0 10, !important);
        height: 1px !important;
        background-color: rgba-to-rgb(rgba($white, 0.3), $brand-almost-dark);
    }

    .vue-slider-rail {
        background-color: rgba-to-rgb(rgba($white, 0.3), $brand-almost-dark);
    }

    .vue-slider-process {
        @include scale(margin-left, -10, -10, -10);
        background-color: $brand-accent !important;
    }

    .vue-slider-dot {
        @include transition(width, height);
        @include scale(width, 20, 20, 20, !important);
        @include scale(height, 20, 20, 20, !important);
        position: relative;
        z-index: z(default) !important;

        &:after {
            @include pseudo();
            @include scale(top, -5, -5, null);
            @include scale(left, -10, -10, null);
            @include scale(right, -10, -10, null);
            @include scale(bottom, -10, -10, null);
            z-index: z(default);
            background-color: transparent;
            cursor: pointer;

            @media #{$laptop} {
                display: none;
            }
        }

        &:hover {
            .vue-slider-dot-handle {
                // Media
                @media #{$laptop} {
                    background-color: $white;
                }
            }
        }

        &.vue-slider-dot-focus {
            .vue-slider-dot-handle {
                background-color: $white;
            }
        }
    }

    [class^="no-change"] {
        .vue-slider-dot {
            @include scale(width, 16, 16, 16, !important);
            @include scale(height, 16, 16, 16, !important);
        }
    }

    .vue-slider-dot-handle {
        @include transition(background);
        background-color: $brand-accent-dark !important;
        box-shadow: none;
        border: 2px solid $white;

        &:hover {
            // Media
            @media #{$laptop} {
                background-color: $white;
            }
        }
    }
</style>
